/*
  Cartes produit « resserrées » — alignement (voir assets/gv-cartes-resserrees.css).
  Les cartes n'ont plus de hauteurs réservées : pour que titres, ligne note/prix et « Idéale pour » restent
  alignés d'une carte à l'autre, chaque bloc reçoit la hauteur du plus long de son groupe :
    - carrousel (Swiper) : toutes les cartes du carrousel (une seule rangée, même hors écran) ;
    - grille (collections, recherche, Sélection de Paul, pages par usage…) : les cartes d'une même rangée visuelle ;
    - une carte seule sur sa rangée garde sa hauteur naturelle.
  La section « Quelle vanille pour votre recette ? » ([data-gva-section]) a son propre script : ignorée ici.
  Déclenché par minuteries et événements (le « scanner » du thème peut geler les observateurs sur certaines
  pages) : chargement, polices, redimensionnement, clic / changement (onglets, filtres, tri), éditeur de thème.
*/
(function () {
  if (window.gvCartesResserrees) return;

  var BLOCS = ['.pc-title-row', '.pc-meta-row', '.pc-ideale'];
  var CARTE = 'product-card.card--product--v2';

  function cartes() {
    return [].slice.call(document.querySelectorAll(CARTE)).filter(function (c) {
      return !c.closest('[data-gva-section]');
    });
  }

  function groupes(liste) {
    var parConteneur = new Map();
    liste.forEach(function (c) {
      if (!c.getClientRects().length) return; /* carte masquée : filtre, onglet, tiroir fermé */
      var cont = c.closest('.swiper-wrapper') ||
        c.closest('.main-list-collection__cards, .gv-selection-grid') ||
        (c.parentElement && c.parentElement.parentElement);
      if (!cont) return;
      if (!parConteneur.has(cont)) parConteneur.set(cont, []);
      parConteneur.get(cont).push(c);
    });
    var res = [];
    parConteneur.forEach(function (l, cont) {
      if (cont.classList.contains('swiper-wrapper')) { res.push(l); return; }
      var rangs = [];
      l.forEach(function (c) {
        var t = c.getBoundingClientRect().top, r = null;
        for (var i = 0; i < rangs.length; i++) if (Math.abs(rangs[i].t - t) < 3) { r = rangs[i]; break; }
        if (r) r.l.push(c); else rangs.push({ t: t, l: [c] });
      });
      rangs.forEach(function (r) { res.push(r.l); });
    });
    return res;
  }

  function egaliser() {
    /* police définitive pas encore là : un alignement maintenant serait faux puis corrigé (saut) → attendre */
    if (document.fonts && document.fonts.status === 'loading') {
      document.fonts.ready.then(function () { plusTard(0); });
      return;
    }
    document.documentElement.classList.add('gv-cr-ok');
    var l = cartes();
    /* 1. hauteurs naturelles : retirer l'alignement précédent (écritures groupées) */
    l.forEach(function (c) {
      BLOCS.forEach(function (sel) {
        var e = c.querySelector(sel);
        if (e && e.style.getPropertyValue('min-height')) e.style.removeProperty('min-height');
      });
    });
    /* 2. mesures (lectures groupées) */
    var plan = [];
    groupes(l).forEach(function (g) {
      if (g.length < 2) return;
      BLOCS.forEach(function (sel) {
        var els = g.map(function (c) { return c.querySelector(sel); }).filter(Boolean);
        if (els.length < 2) return;
        var m = 0;
        els.forEach(function (e) { m = Math.max(m, e.getBoundingClientRect().height); });
        if (m > 0) plan.push([els, Math.ceil(m * 10) / 10]);
      });
    });
    /* 3. alignement (!important : gv-selector.css impose min-height:0 / 21px !important sur ces blocs) */
    plan.forEach(function (p) {
      p[0].forEach(function (e) { e.style.setProperty('min-height', p[1] + 'px', 'important'); });
    });
    pastilles();
  }

  /* Pastille « La sélection de Paul » : TOUJOURS à la même place, en haut à gauche, sur toutes les cartes
     (retour de Paul, 28/09 : « le −15 % n'est pas affiché comme les autres »). Quand la carte est trop étroite
     pour qu'elle et les étiquettes de droite (Givrée, Rupture, De retour…) tiennent sur la même ligne, ce sont
     les étiquettes qui passent juste sous la pastille (décalage en transform : sans effet sur la mise en page).
     Mesure faite à la place normale des étiquettes (décalage en cours retranché) : aucune écriture inutile. */
  var ETIQ = '.product-card__tag, .gv-card-oos-tag, .gv-card-retour-tag, .gv-card-recolte-tag';
  function touche(a, b) { return a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom; }
  function decalage(e) {
    var t = getComputedStyle(e).transform;
    if (!t || t === 'none') return 0;
    try { return new DOMMatrixReadOnly(t).m42; } catch (x) { return 0; }
  }
  function pastilles() {
    document.querySelectorAll(CARTE).forEach(function (c) {
      var visible = function (e) { return e.getClientRects().length; };
      if (!visible(c)) return; /* carte masquée (onglet, filtre) : elle garde son dernier état */
      var chip = [].slice.call(c.querySelectorAll('.pc-promo-chip')).filter(visible)[0];
      var tags = chip ? [].slice.call(c.querySelectorAll(ETIQ)).filter(visible) : [];
      var dy = 0;
      if (tags.length) {
        var r = chip.getBoundingClientRect(), gene = false, haut = Infinity;
        tags.forEach(function (t) {
          var q = t.getBoundingClientRect(), d = decalage(t);
          q = { left: q.left, right: q.right, top: q.top - d, bottom: q.bottom - d };
          if (touche({ left: r.left, right: r.right + 6, top: r.top, bottom: r.bottom }, q)) gene = true; /* 6 px d'air, comme dessous */
          haut = Math.min(haut, q.top);
        });
        if (gene) dy = Math.ceil(r.bottom + 6 - haut);
      }
      if (dy > 0) {
        if (c.style.getPropertyValue('--gv-etiq-dy') !== dy + 'px') c.style.setProperty('--gv-etiq-dy', dy + 'px');
        if (c.getAttribute('data-gv-pastille') !== 'etiquettes') c.setAttribute('data-gv-pastille', 'etiquettes');
      } else {
        if (c.hasAttribute('data-gv-pastille')) c.removeAttribute('data-gv-pastille');
        if (c.style.getPropertyValue('--gv-etiq-dy')) c.style.removeProperty('--gv-etiq-dy');
      }
    });
  }

  var minuterie;
  function plusTard(d) { clearTimeout(minuterie); minuterie = setTimeout(egaliser, d); }
  function apresAction() { plusTard(200); setTimeout(egaliser, 900); }

  window.gvCartesResserrees = egaliser;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', egaliser);
  else egaliser();
  window.addEventListener('load', function () { plusTard(0); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { plusTard(0); });
  window.addEventListener('resize', function () { plusTard(120); });
  document.addEventListener('click', apresAction, true);
  document.addEventListener('change', apresAction, true);
  /* pastilles : tout de suite après les gestionnaires d'onglets / filtres (phase de bouillonnement), sans attendre
     les minuteries — y compris les onglets changés au clavier (flèches, Début, Fin) */
  document.addEventListener('click', function () { pastilles(); });
  document.addEventListener('keydown', function (e) {
    if (e.target && e.target.closest && e.target.closest('[role="tab"], [role="tablist"]')) { pastilles(); plusTard(60); }
  });
  document.addEventListener('shopify:section:load', function () { plusTard(100); });
  /* carrousels initialisés en différé (w-product-slider.js), images et avis chargés ensuite */
  setTimeout(egaliser, 400);
  setTimeout(egaliser, 1500);
})();
